import { useState, useEffect } from 'react'

import Api from 'services/api'

const useDevicesHasMetrics = () => {
  const [deviceIds, setDeviceIds] = useState([])
  const [areDeviceIdsLoaded, setAreDeviceIdsLoaded] = useState(false)

  useEffect(() => {
    Api.DeviceMetrics.getDevicesHasMetrics()
      .then((res) => {
        setDeviceIds(res.deviceIds)
      }).catch(() => {
        setDeviceIds([])
      }).finally(() => {
        setAreDeviceIdsLoaded(true)
      })
  }, [])

  return { deviceIds, areDeviceIdsLoaded }
}

export default useDevicesHasMetrics
